<template>
  <div v-if="notification" class="header-cart-notification">
    <oie-cart-product-item-notification :cart-row="notification.meta" :close-notification-handler="desmissNotification"></oie-cart-product-item-notification>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    useAutoClose: {
      type: Boolean,
      default: true
    },
    duration: {
      type: Number,
      default: 2000
    }
  },
  data: () => ({
    notification: null
  }),
  computed: {
    ...mapGetters('ui', ['notifications'])
  },
  watch: {
    notifications() {
      const notification = _.last(this.notifications)

      if (notification.destination === undefined || notification.destination !== 'cart') {
        return
      }

      this.notification = notification

      if (this.useAutoClose) {
        setTimeout(() => {
          this.notification = null
        }, this.duration)
      }
    }
  },
  methods: {
    desmissNotification() {
      this.notification = null
    }
  }
}
</script>

<style lang="scss" scoped>
.header-cart-notification {
  right: 0;
  background-color: color(background-white);
  box-shadow: -3px 7px 16px 0 rgba(93, 92, 92, .5);
  color: color(text);
  z-index: 1;

  @include media(to-small) {
    position: fixed;
    top: 4rem;
    left: 0;
  }

  @include media(small) {
    position: absolute;
    top: 100%;
    width: other(cart-width);
    margin-top: measure(quarter);
  }
}
</style>
